var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Ad-container"},_vm._l((_vm.adList),function(ad,index){return _c('a',{key:'ad'+index,attrs:{"title":ad.Title,"target":"_blank","href":ad.NavUrl}},[_c('img',{attrs:{"src":_vm.getImgUrl(ad.ImgUrl)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }